import {$dom} from "../helpers/dom";
import landingRedragonPage from "./components/redragon";
import landingRedragonComponents from "./components/redragon/_components";

$dom.ready(function() {
    this.currentPage = landingRedragonPage;

    this.currentPage && this.currentPage.init(landingRedragonComponents);
});
